import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { calculatePasswordStrength, getPasswordRequirements } from '../../utils/passwordValidation';

const PasswordStrengthIndicator = ({ password, className = '' }) => {
 const passwordStrength = calculatePasswordStrength(password);
 const requirements = getPasswordRequirements();

 if (!password) return null;

 return (
 <div className={`space-y-2 ${className}`}>
 <div className="flex items-center justify-between text-xs">
 <span className="text-gray-600">Password Strength:</span>
 <span className={`font-medium ${ passwordStrength.strength <= 2 ? 'text-red-600' : passwordStrength.strength <= 4 ? 'text-yellow-600' : passwordStrength.strength <= 5 ? 'text-ink' : 'text-green-600' }`}>
 {passwordStrength.label}
 </span>
 </div>
 <div className="w-full bg-gray-200 rounded-full h-2">
 <div
 className={`h-2 rounded-full transition-all ${ passwordStrength.strength <= 2 ? 'bg-red-500' : passwordStrength.strength <= 4 ? 'bg-yellow-500' : passwordStrength.strength <= 5 ? 'bg-ink' : 'bg-green-500' }`}
 style={{ width: `${(passwordStrength.strength / 6) * 100}%` }}
 />
 </div>
 
 {/* Password Requirements */}
 <div className="mt-3 space-y-1.5">
 <p className="text-xs font-medium text-gray-700 mb-2">Password Requirements:</p>
 <div className="space-y-1">
 {requirements.map((req) => {
 const isMet = passwordStrength.requirements[req.key];
 return (
 <div
 key={req.key}
 className={`flex items-center text-xs ${isMet ? 'text-gray-600' : 'text-gray-400'}`}
 >
 {isMet ? (
 <CheckCircle className="w-3.5 h-3.5 mr-2 text-green-500 flex-shrink-0" />
 ) : (
 <XCircle className="w-3.5 h-3.5 mr-2 text-gray-400 flex-shrink-0" />
 )}
 {req.label}
 </div>
 );
 })}
 </div>
 </div>
 </div>
 );
};

export default PasswordStrengthIndicator;

